import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

export const marketplaceRequestSlice = createSlice({
  name: "MarketplaceRequest",
  initialState,
  reducers: {
    addItemToRequest: (state, action) => {
      const {
        providerId,
        providerName,
        providerMessage,
        email,
        item,
        quantity = 1,
      } = action.payload;

      const existing = state.items.find((i) => i.id === item.id);
      if (existing) {
        existing.quantity += quantity;
      } else {
        state.items.push({
          id: item.id,
          name: item.name,
          imageUrl: item.imageUrl,
          description: item.description,
          quantity,
          hasQuantitySelector: item.quantity !== false,
          providerId,
          providerName,
          providerMessage,
          email,
        });
      }
    },

    updateItemQuantity: (state, action) => {
      const { itemId, quantity } = action.payload;
      const existing = state.items.find((i) => i.id === itemId);
      if (!existing) return;

      if (quantity <= 0) {
        state.items = state.items.filter((i) => i.id !== itemId);
      } else {
        existing.quantity = quantity;
      }
    },

    removeItemFromRequest: (state, action) => {
      const { itemId } = action.payload;
      state.items = state.items.filter((i) => i.id !== itemId);
    },

    clearRequest: (state) => {
      state.items = [];
    },
  },
});

export const { addItemToRequest, updateItemQuantity, removeItemFromRequest, clearRequest } =
  marketplaceRequestSlice.actions;

export const getRequestItems = (state) => state.marketplaceReducer.items;
export const getRequestItemCount = (state) =>
  state.marketplaceReducer.items.reduce((acc, i) => acc + i.quantity, 0);

export default marketplaceRequestSlice.reducer;
